export enum QueryKeyList {
  UserOrganizationLocationQueryKey = 'cf7fc071-d9f1-42e0-9c44-2170811837ce',
  AppointmentQueryKey = '29cbe89b-5868-431e-a085-c4331eaed3e5',
  ExamDataQueryKey = 'bdc1b062-96cb-4f84-8c5a-a43af096786d',
}
